module.exports = __webpack_public_path__ + "media/images/img-hobby-12-9bdeed6d.jpg";